<!--  -->
<template>
  <div>
    <ul class="lit03">
      <li v-for="item in productNav" :key="item.title">
        <div class="cont_r_b04">
          <div class="cont_r_b05">
            <img :src="item.img" width="158" height="109">
          </div>
          <div class="cont_r_b06">
            <div class="cont_r_b07">
              <p></p>
            </div>
            <div class="cont_r_b09">
              <p></p>
              <p>
                <span style="font-family:&quot;color:black;">
                  <strong>
                    <u>{{item.title}}</u>
                  </strong>
                </span>
              </p>
              <p>
                <span style="font-family:&quot;color:black;">
                  <span></span>
                </span>
                <span style="font-family:&quot;color:black;">
                  <br>
                </span>
              </p>
              <p style="font-family:&quot;color:black;" v-html="item.word"></p>
              <p></p>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      productNav: [
        {
          title: "有色金属",
          word:
            "黄铜锭（LS59, LS60, M70）, 青铜锭（Br0312），紫铜锭（M98.M99）<br />铝卷，铝板，铝箔（1, 3, 5 系），罐身料<br />重熔铅锭（Grade #1, #2），重熔锌锭（Grade #1, #2）",
            img: require("../../../assets/img/common/home1.jpg")
        },
        {
          title: "矿产品、稀土及铁合金",
          word:
            "铬矿(Grade: 32% Cr, 36% Cr, 42% Cr)，锰矿<br /> 混合稀土金属<br />稀土硅合金（Re Silicide: Re 30%, Re 10%）<br />金属硅（Grade 553, 441, 2202, 3303）<br />镍铁（FeNi: Ni 10%, Ni 20%, Ni 50%），硅铁（FeSi75%, FeSi72%, FeSi65%）<br />锰铁，硅锰，钼铁，铬铁，钛铁，钒铁",
          img: require("../../../assets/img/common/home2.jpg")
        },
        {
          title: "炭素制品及冶金煤",
          word:
            "电极（炭电极: 直径 800mm–1272mm, 石墨电极: 直径800mm-1146mm）<br />铝用炭块，预焙阳极，电极糊，石墨块，煅后焦，增碳剂<br />冶金煤",
          img: require("../../../assets/img/common/home3.jpg")
        },
        {
          title: "医药保健原料",
          word:
            "硫酸软骨素，氨基葡萄糖硫酸钾盐，氨基葡萄糖盐酸盐<br />石杉碱甲，茶叶提取物，茶黄素，速溶茶，葛根提取物，水飞蓟提取物<br />葡萄籽提取物， L-肉碱，L-酪氨酸，L-精氨酸，à-硫辛酸",
          img: require("../../../assets/img/common/home4.jpg")
        },
        {
          title: "化工原料",
          word: "钛白粉，无水碳酸钠，氟化铝，人造冰晶石",
          img: require("../../../assets/img/common/home5.jpg")
        },
        {
          title: "钢铁及炉料",
          word:
            "金属锰锭(Mn 95% min)，金属锰片(Mn 99.7%min)，金属锰枕(Mn 97%min)<br />金属镁锭，金属镁粉(Mg 99.9%min, Mg 97%+CaO 3%)<br /> 金属钙粒(Ca 98.5% max)<br /> 包芯线",
          img: require("../../../assets/img/common/home6.gif")
        }
      ]
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/product/productsy.vue